module.exports = __webpack_public_path__ + "static/media/log-in-new.2f959cc6.svg";